var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2401 3.338L10.0016 3.33398C6.55086 3.33398 3.44101 5.76989 1.71739 9.75551C1.64971 9.91202 1.64971 10.0893 1.71739 10.2458L1.83682 10.5146C3.53861 14.2449 6.4795 16.5543 9.75979 16.6633L9.99829 16.6673C13.4491 16.6673 16.5589 14.2314 18.2825 10.2458C18.3511 10.0873 18.3502 9.90765 18.28 9.74985L18.164 9.48868C16.4581 5.75141 13.5159 3.44687 10.2401 3.338ZM10.0075 4.57517L10.2066 4.57945L10.4291 4.59103C13.0934 4.77968 15.5437 6.75526 17.0241 9.99991L17.0164 10.0199C15.4989 13.3344 12.9641 15.3217 10.2157 15.4214L10.0033 15.4246L9.78907 15.4218L9.56713 15.4102C6.98555 15.2274 4.60527 13.3627 3.11591 10.3004L2.97496 9.99991L3.10544 9.72248C4.67594 6.47827 7.24286 4.57587 10.0075 4.57517ZM9.99954 6.76187C8.19921 6.76187 6.74038 8.21159 6.74038 10.0008C6.74038 11.7894 8.19936 13.2389 9.99954 13.2389C11.7998 13.2389 13.2595 11.7893 13.2595 10.0008C13.2595 8.21169 11.8 6.76187 9.99954 6.76187ZM9.99954 8.0038C11.1097 8.0038 12.0095 8.89765 12.0095 10.0008C12.0095 11.1033 11.1096 11.997 9.99954 11.997C8.88972 11.997 7.99038 11.1035 7.99038 10.0008C7.99038 8.89743 8.88962 8.0038 9.99954 8.0038Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectView);
export default __webpack_public_path__ + "static/media/project-view.df25137946d1bfa5c6ea2f5357ce343f.svg";
export { ForwardRef as ReactComponent };